import OrdersModal from './ordersModal'

export default OrdersModal